import React from "react";
import { Helmet } from "react-helmet";
import PagoBancaria from "../../components/paet/FormFormaPago";
import { aacento } from "../../utils/caracteresUTF8";

export default function Pago() {
    return (
        <>
            <Helmet>
                <title>Retiro Enfermos Terminales AFP Modelo | Solicitud de Retiro Enfermos Terminales | AFP Modelo</title>
                <meta name="description" content={``} />
                <meta name="robots" content="noindex, follow" />
            </Helmet>
            <section>
                <div className="container">
                    <div className="card formulario mt-5 mb-5">
                        <div className="card-header">
                            <div className="form-row">
                                <div className="titulo">
                                    Retiro de Pensión Anticipada por Enfermedad Terminal (PAET)
                                </div>
                            </div>
                            <div className="form-row">
                                <div className="subtitulo mt-3">
                                    1- Ingresa la forma de pago principal(Obligatoria)
                                </div>
                            </div>
                        </div>
                        <div className="card-body paet">
                            <span>
                                La cuenta bancaria debe pertenecer al afiliado o beneficiario de sobrevivencia. Si eres mandatario y est{aacento}s autorizado para realizar el cobro, puedes ingresar tu cuenta bancaria.
                            </span>
                            <PagoBancaria />
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}